import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "field"]
  static values = { options: Array }

  connect() {
    this.sync()
  }

  sync(event) {
    const changedLevel = event ? this.selectTargets.indexOf(event.target) : 0

    for (let level = changedLevel + 1; level < this.selectTargets.length; level++) {
      this.syncLevel(level)
    }
  }

  syncLevel(level) {
    const options = this.optionsValue[level - 1][this.selectTargets[level - 1].value] || []

    this.replaceOptions(this.selectTargets[level], options)
    this.fieldTargets[level].classList.toggle("tw-hidden", options.length < 2)
  }

  replaceOptions(select, options) {
    const sole = options.length === 1
    const previousValue = select.value
    const values = options.map((option) => option.value)
    const nextValue = sole ? values[0] : (values.includes(previousValue) ? previousValue : "")

    select.innerHTML = ""
    if (!sole) select.appendChild(new Option("", ""))
    options.forEach((option) => {
      select.appendChild(new Option(option.label, option.value, false, option.value === nextValue))
    })
    select.value = nextValue

    if (nextValue !== previousValue) select.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
